import { render, staticRenderFns } from "./ModificheInCoda.vue?vue&type=template&id=5304dc82"
import script from "./ModificheInCoda.vue?vue&type=script&lang=js"
export * from "./ModificheInCoda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports